import React from 'react';

import { Article, SNIPPET_TYPE } from '@repo/types';

import { TabsComponent } from './article-snippets-tabs/tabs-component';

interface ArticleSnippetsTabsProps {
  currTab: SNIPPET_TYPE;
  setCurrTab: (tab: SNIPPET_TYPE) => void;
  articleMetrics?: Article;
}

export const PureArticleSnippetsTabs: React.FC<ArticleSnippetsTabsProps> = ({
  currTab,
  setCurrTab,
  articleMetrics,
}) => {
  const snippets = articleMetrics?.snippets || [];

  // Analytics wire id: the SLUG (matches analysis_opened.article_id on web);
  // numeric backend id only as a fallback for un-slugged payloads.
  const articleId =
    articleMetrics?.slug ??
    (articleMetrics ? String(articleMetrics.id) : undefined);

  return (
    <TabsComponent
      snippets={snippets}
      currTab={currTab}
      setCurrTab={setCurrTab}
      articleId={articleId}
    />
  );
};
